module.exports = __webpack_public_path__ + "img/block_01_img.48541471.png";